import React from 'react';
import './ToggleViewModeButton.scss';
import { Icons } from '../../utilities/Icons/Icons';
import { THREE_D_TYPE } from '../../utilities/constants/Constants';

const toggleViewModeButton = props => {
  const { viewType, clickHandler } = props;
  return (
    <div className='viewModeContainer'>
      <button type='button' className='toggleButton' onClick={clickHandler}>
        <img
          className='toggleIcon'
          src={
            viewType == THREE_D_TYPE
              ? Icons.twoDVisualizeIcon
              : Icons.threeDVisualizeIcon
          }
          alt='view_mode_icon'
        />
        <span className='toggleText'>
          {viewType == THREE_D_TYPE ? '2D view' : '3D view'}{' '}
        </span>
      </button>
    </div>
  );
};

export default toggleViewModeButton;
